// ui/src/Forms/Loaders/components/DatePickerSkeleton.js
import { Mui } from "@osu/react-ui";

function DatePickerSkeleton() {
  return (
    <Mui.Box sx={{ mb: 3 }}>
      <Mui.Skeleton variant="text" width="30%" height={24} />
      <Mui.Skeleton variant="rectangular" width="40%" height={56} />
    </Mui.Box>
  );
}

export default DatePickerSkeleton;
